import { useQuery } from "@tanstack/react-query";
import { getStatsInterventions } from "../../api/STATISTIQUES/statistiques";

export const useStatsInterventions = (filters = {}) => {
  return useQuery({
    queryKey: ["statsInterventions", filters],
    queryFn: () => getStatsInterventions(filters),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
